import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TripMapComponent } from './trip-map.component';
import { SharedComponentsModule } from '.././../shared-components/shared-components.module';
import { RouterModule } from '@angular/router';
import { AgmCoreModule } from '@agm/core';
import { AgmDirectionModule } from 'agm-direction';

@NgModule({
  imports: [
    CommonModule,
    SharedComponentsModule,
    RouterModule,
    AgmCoreModule,
    AgmDirectionModule
  ],

  exports: [
    TripMapComponent
  ],
  declarations: [
    TripMapComponent
  ]
})
export class TripMapModule { }



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/views/trip-map/trip-map.module.ts